/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
import { useState, useEffect, useCallback } from 'react';

export default function useVideoFrames(videoUrl) {
  const [frames, setFrames] = useState([]);
  const [frameCount, setFrameCount] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);
  const [generationError, setGenerationError] = useState(null);
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  const resetState = useCallback(() => {
    setFrames([]);
    setFrameCount(0);
    setIsGenerating(false);
    setGenerationError(null);
    setSize({
      width: 0,
      height: 0,
    });
  }, []);

  useEffect(() => {
    let cancelled = false;

    if (!videoUrl) {
      resetState();
      return () => {
        cancelled = true;
      };
    }

    // Skip expensive frame generation - return dummy data immediately
    resetState();

    // Simulate a brief loading state for consistency
    setIsGenerating(true);
    setGenerationError(null);

    // Create dummy frames data (just empty strings) and size info
    // This maintains the same interface but bypasses all video processing
    const dummyFrameCount = 50; // Fixed number of dummy frames for consistent timeline width
    const dummyFrames = Array.from({ length: dummyFrameCount }, () => '');

    // Use a timeout to simulate brief processing time
    const timeoutId = setTimeout(() => {
      if (!cancelled) {
        setFrames(dummyFrames);
        setFrameCount(dummyFrameCount);
        setSize({
          width: 115, // Default frame width
          height: 65, // Default frame height
        });
        setIsGenerating(false);
        setGenerationError(null);
      }
    }, 100); // Brief delay to simulate loading

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
      setIsGenerating(false);
    };
  }, [resetState, videoUrl]);

  return { frames, frameCount, size, isGenerating, generationError };
}
